/**
 * RaceDashboard Page
 *
 * Landing page for /race with:
 * - Host a Race button
 * - Race History list
 */

import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { RaceHistory } from '@/components/Race/RaceHistory';
import styles from '@/components/Race/Race.module.css';

export function RaceDashboard() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className={styles.raceContainer}>
        <div className={styles.authPrompt}>
          <h2>Please sign in to host races</h2>
          <p>You need to be signed in to host races and view your race history.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.raceContainer}>
      <div className={styles.dashboardHeader}>
        <h1 className={styles.pageTitle}>Race</h1>
        <button
          className={styles.hostButton}
          onClick={() => navigate('/race/host')}
        >
          Host a Race
        </button>
      </div>

      <div className={styles.dashboardSection}>
        <h2 className={styles.sectionTitle}>History</h2>
        <RaceHistory />
      </div>
    </div>
  );
}
